import { window } from "global";
import React, { useEffect, useState, useRef } from "react";
import { useGlobal } from "reactn";
import { useQuery } from "@apollo/client";

import Footer from "components/SideNav/Footer";
// import NewLeagueLinks from "components/SideNav/NewLeagueLinks";
import NewLeagueLinks from "components/SideNav/NewSideNavLinks";
import { Link } from "react-router-dom";
import { getActiveName } from "components/SideNav/IsActive";
import { generateTierList, convertToRoleTierList } from "lib/FilterPreferences/QueryParams";
import { useSideNav } from "hooks/general-hooks";
import { GET_USER_STATE } from "api/graphql/queries";
import { shouldOpenSideNav, parseQueryString } from "lib/general-helper";
import MediaQuery from "components/MediaQuery";
import SearchBar from "components/SearchBar";
import { useLoginState } from "lib/hooks/userHooks";
import { useUserSummonerName } from "../lib/hooks/userHooks";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { useLightMode } from "hooks/general-hooks";
import { ReactComponent as UggLogoU } from "../svg/logos/ugg-u-logo.svg";
import { ReactComponent as UggLogoUDark } from "../svg/logos/ugg-u-logo-dark.svg";
import { ReactComponent as FullUggLogo } from "../svg/logos/ugg-logo-blue.svg";
import { ReactComponent as FullUggLogoDark } from "../svg/logos/ugg-logo-blue-dark.svg";
import { ReactComponent as LeftArrow } from "../svg/left-arrow.svg";
import { ReactComponent as LeftArrowLightMode } from "../svg/left-arrow-light-mode.svg";
import { ReactComponent as BlueManPlus } from "../svg/blue-man-plus.svg";
import { ReactComponent as ThreeDots } from "../svg/three-dots.svg";
import { ReactComponent as ThreeDotsDark } from "../svg/three-dots-dark.svg";
import FeedbackForm from "./Masthead/Feedback/FeedbackForm";

const NewFooter = (props) => {
  const [windowBreakpoint] = useGlobal("responsive");
  const [manualSideNav, setManualSideNav] = useGlobal("manualSideNav");
  const { lightModeOn } = useLightMode();
  const isLoggedIn = useLoginState();
  const userData = useUserSummonerName();
  const { loading, data, error } = useQuery(GET_USER_STATE);
  const { getState } = data || {};
  const { lolSettings } = getState || {};
  const { summoners } = lolSettings || {};
  const summoner = (summoners && summoners[0]) || {};
  const { summonerName = "", regionId = "", iconId = "" } = summoner || {};
  const [expandedSideNav, setExpandedSideNav] = useSideNav();
  const interactedWithSideNav = windowBreakpoint === "DESKTOP_LARGE" || manualSideNav;
  const collapsed = interactedWithSideNav && expandedSideNav ? "expanded" : "collapsed";
  const [feedbackState, setFeedbackPopup] = useState(false);

  const { getProfileIconImg } = getRiotAssetsContext();

  const [showXtraInfo, setShowXtraInfo] = useState(false);

  const handleExtraInfo = () => {
    setShowXtraInfo(!showXtraInfo);
  };

  const toggleFeedbackPopup = () => {
    setFeedbackPopup(!feedbackState);
  };

  if (isLoggedIn) {
    let region = userData.regionId;
    let summonerName = userData.summonerName;

    let profile_path = "/lol/profile/" + region + "/" + summonerName + "/overview";

    return (
      <div className="logged-out-footer">
        {collapsed === "expanded" && (
          <>
            {lightModeOn ? (
              <ThreeDotsDark
                className="three-dots"
                onClick={handleExtraInfo}
                style={{ background: showXtraInfo ? "#5C5C8E" : "" }}
              />
            ) : (
              <ThreeDots className="three-dots" onClick={handleExtraInfo} style={{ background: showXtraInfo ? "#5C5C8E" : "" }} />
            )}
            {showXtraInfo && (
              <div className="otherInfo">
                <div>
                  <Link to="/about">About</Link>
                </div>
                <div>
                  <Link to="/faq">FAQ</Link>
                </div>
                <div>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </div>
                <div>
                  <Link to="/privacy-shield">Privacy Shield</Link>
                </div>
                <div>
                  <Link to="/careers">Careers</Link>
                </div>
                <div>
                  <Link to="/terms-of-service">Terms of Service</Link>
                </div>
                <div>
                  <a onClick={toggleFeedbackPopup} style={{ cursor: "pointer" }}>
                    Contact Us
                  </a>
                  {feedbackState ? <FeedbackForm toggleFeedbackPopup={toggleFeedbackPopup} /> : null}
                </div>
              </div>
            )}
            <Link to={profile_path}>
              <img
                className="footer-pp"
                src={iconId ? getProfileIconImg(iconId) : "https://static.bigbrain.gg/assets/ugg/icons/profile-icon.svg"}
              />
            </Link>
            <div className="guest-container">
              <Link to={profile_path}>
                {summonerName}
                <div className="online-dot" />
              </Link>
              <div className="online">Online</div>
            </div>
          </>
        )}
        {collapsed === "collapsed" && (
          <Link to={profile_path}>
            <img
              className="footer-pp"
              src={iconId ? getProfileIconImg(iconId) : "https://static.bigbrain.gg/assets/ugg/icons/profile-icon.svg"}
            />
            <div className="online-dot" />
          </Link>
        )}
      </div>
    );
  } else {
    return (
      <div className="logged-out-footer">
        {collapsed === "expanded" && (
          <>
            {lightModeOn ? (
              <ThreeDotsDark
                className="three-dots"
                onClick={handleExtraInfo}
                style={{ backgroundColor: showXtraInfo ? "#5C5C8E" : "" }}
              />
            ) : (
              <ThreeDots
                className="three-dots"
                onClick={handleExtraInfo}
                style={{ backgroundColor: showXtraInfo ? "#5C5C8E" : "" }}
              />
            )}
            {showXtraInfo && (
              <div className="otherInfo">
                <div>
                  <Link to="/about">About</Link>
                </div>
                <div>
                  <Link to="/faq">FAQ</Link>
                </div>
                <div>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </div>
                <div>
                  <Link to="/privacy-shield">Privacy Shield</Link>
                </div>
                <div>
                  <Link to="/careers">Careers</Link>
                </div>
                <div>
                  <Link to="/terms-of-service">Terms of Service</Link>
                </div>
                <div>
                  <a onClick={toggleFeedbackPopup} style={{ cursor: "pointer" }}>
                    Contact Us
                  </a>
                  {feedbackState ? <FeedbackForm toggleFeedbackPopup={toggleFeedbackPopup} /> : null}
                </div>
              </div>
            )}
            <Link to={"/login"}>
              <BlueManPlus className="svg-checker" />
            </Link>
            <div className="guest-container">
              <Link to="/login">Guest</Link>
              <div className="guest-status">
                <Link to="/login">Logged Out</Link>
              </div>
            </div>
          </>
        )}
        {collapsed === "collapsed" && (
          <Link to={"/login"}>
            <BlueManPlus className="svg-checker" />
          </Link>
        )}
      </div>
    );
  }
};

const NewSideNav = (props) => {
  const sideNavRef = useRef();
  const [windowBreakpoint] = useGlobal("responsive");
  const [manualSideNav, setManualSideNav] = useGlobal("manualSideNav");
  const [expandedSideNav, setExpandedSideNav] = useSideNav();
  const { data: userState } = useQuery(GET_USER_STATE);
  const { filterDefaults } = (userState && userState.getState) || {};
  const [verificationBar] = useGlobal("verificationBar");
  const interactedWithSideNav = windowBreakpoint === "DESKTOP_LARGE" || manualSideNav;
  const { lightModeOn } = useLightMode();
  const [init, setInit] = useState(false);

  const toggledSideNav = () => {
    !manualSideNav && setManualSideNav(true);
    (interactedWithSideNav || !expandedSideNav) && setExpandedSideNav(!expandedSideNav, { saveToggle: true });
  };

  useEffect(() => {
    if (window) {
      setInit(true);
    }
  }, []);

  const collapsed = interactedWithSideNav && expandedSideNav ? "expanded" : "collapsed";
  const linkActiveName = getActiveName();

  const verificationBarActive = verificationBar ? "verification-bar-active" : "";
  const queryParams = generateTierList(filterDefaults);
  const tierListLocation = convertToRoleTierList(parseQueryString(queryParams.substring(1)));
  let tierListPathname = `${tierListLocation.pathname}?${tierListLocation.search}`;

  let links = <NewLeagueLinks linkActiveName={linkActiveName} tierListPathname={tierListPathname} collapsed={collapsed} />;

  /* Uncomment to make sidenav load on server as expanded placeholder. */
  if (!window || !init) {
    return (
      <div ref={sideNavRef} id="side-nav-container" className={`collapsed`}>
        <div id="side-nav" className={`collapsed ${verificationBarActive}`}></div>
      </div>
    );
  }

  if (collapsed === "collapsed") {
    return (
      <div ref={sideNavRef} id="side-nav-container" className={`${collapsed}`} onMouseEnter={toggledSideNav}>
        {/* verification-bar-active or "" */}
        <div id="new-side-nav" className={`${collapsed} ${verificationBarActive}`} style={{ transitionDuration: "0.25s" }}>
          <div className="area-to-expand" onTouchEnd={toggledSideNav} />
          <div className="sidebar-head">
            {lightModeOn ? (
              <div className="sidebar-ugg-logo">
                <UggLogoUDark />
              </div>
            ) : (
              <div className="sidebar-ugg-logo">
                <UggLogoU />
              </div>
            )}
          </div>
          <div className="side-nav-links">{links}</div>
          <div className="filler" />
          <NewFooter />
        </div>
      </div>
    );
  } else {
    return (
      <div ref={sideNavRef} id="side-nav-container" className={`${collapsed}`} onMouseLeave={toggledSideNav}>
        {/* verification-bar-active or "" */}
        <div id="new-side-nav" className={`${collapsed} ${verificationBarActive}`} style={{ transitionDuration: "0.25s" }}>
          <div className="sidebar-head" onTouchEnd={toggledSideNav}>
            <MediaQuery min="MOBILE_SMALL" max="TABLET">
              {lightModeOn ? (
                <div className="sidebar-ugg-logo">
                  <FullUggLogoDark style={{ height: "39px", width: "80px" }} />
                </div>
              ) : (
                <div className="sidebar-ugg-logo">
                  <FullUggLogo style={{ height: "39px", width: "80px" }} />
                </div>
              )}
            </MediaQuery>
            <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE">
              {lightModeOn ? (
                <Link to="/">
                  <div className="sidebar-ugg-logo">
                    <FullUggLogoDark style={{ height: "39px", width: "80px" }} />
                  </div>
                </Link>
              ) : (
                <Link to="/">
                  <div className="sidebar-ugg-logo">
                    <FullUggLogo style={{ height: "39px", width: "80px" }} />
                  </div>{" "}
                </Link>
              )}
            </MediaQuery>
          </div>
          <MediaQuery min="MOBILE_SMALL" max="MOBILE_MEDIUM">
            <div className="masthead-search-bar-container">
              <SearchBar materialDesign placeholder={"Search Summoner or Champion"} isMasthead />
            </div>
          </MediaQuery>
          <div className="side-nav-links">{links}</div>
          <div className="filler" />
          <div className="footer-div">
            <NewFooter />
          </div>
        </div>
      </div>
    );
  }
};

export default NewSideNav;
